/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Timecode_Format_MsInputs */

const en_transcript_export_timecode_format_ms = /** @type {(inputs: Transcript_Export_Timecode_Format_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Millisecond TC (hh:mm:ss.mmm)`)
};

const fr_transcript_export_timecode_format_ms = /** @type {(inputs: Transcript_Export_Timecode_Format_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode millisecondes (hh:mm:ss.mmm)`)
};

const de_transcript_export_timecode_format_ms = /** @type {(inputs: Transcript_Export_Timecode_Format_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Millisekunden-TC (hh:mm:ss.mmm)`)
};

const it_transcript_export_timecode_format_ms = /** @type {(inputs: Transcript_Export_Timecode_Format_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Millisecondo TC (hh:mm:ss.mmm)`)
};

const ru_transcript_export_timecode_format_ms = /** @type {(inputs: Transcript_Export_Timecode_Format_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Миллисекундный TC (чч:мм:сс.ммм)`)
};

const es_transcript_export_timecode_format_ms = /** @type {(inputs: Transcript_Export_Timecode_Format_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC de milisegundos (hh:mm:ss.mmm)`)
};

const zh_cn2_transcript_export_timecode_format_ms = /** @type {(inputs: Transcript_Export_Timecode_Format_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毫秒 TC（hh:mm:ss.mmm）`)
};

const ja_transcript_export_timecode_format_ms = /** @type {(inputs: Transcript_Export_Timecode_Format_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミリ秒 TC (hh:mm:ss.mmm)`)
};

const hi_transcript_export_timecode_format_ms = /** @type {(inputs: Transcript_Export_Timecode_Format_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिलीसेकंड टीसी (hh:mm:ss.mmm)`)
};

const pt_pt2_transcript_export_timecode_format_ms = /** @type {(inputs: Transcript_Export_Timecode_Format_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC em milissegundos (hh:mm:ss.mmm)`)
};

/**
* | output |
* | --- |
* | "Millisecond TC (hh:mm:ss.mmm)" |
*
* @param {Transcript_Export_Timecode_Format_MsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_timecode_format_ms = /** @type {((inputs?: Transcript_Export_Timecode_Format_MsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Timecode_Format_MsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_timecode_format_ms(inputs)
	if (locale === "de") return de_transcript_export_timecode_format_ms(inputs)
	if (locale === "it") return it_transcript_export_timecode_format_ms(inputs)
	if (locale === "ru") return ru_transcript_export_timecode_format_ms(inputs)
	if (locale === "es") return es_transcript_export_timecode_format_ms(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_timecode_format_ms(inputs)
	if (locale === "ja") return ja_transcript_export_timecode_format_ms(inputs)
	if (locale === "hi") return hi_transcript_export_timecode_format_ms(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_timecode_format_ms(inputs)
	return en_transcript_export_timecode_format_ms(inputs)
});